export { Badge } from './Badge';
export type { BadgeProps, BadgeSize, BadgeVariant } from './Badge';
